// PYTHIADEV-3930;
export const getBrandliftQuestionLabelMaxLength = () => {
    return 68;
};

export const getBrandliftOptionsMaxLength = () => {
    return 40;
};
